import { useMemo } from 'react';
import { CreateForm, FormFieldsData, FormTemplateProps } from 'framework/form';
import { FormDraftManager, clearDraft, loadDraft } from './useOneStopFormDraft';

type OneStopCreateFormProps = Omit<FormTemplateProps, 'initialData'> & {
  requestId: string;
  initialData?: FormFieldsData;
  messageContext?: string;
};

const OneStopCreateForm = ({
  requestId,
  initialData = {},
  children,
  messageContext,
  afterSubmit,
  ...rest
}: OneStopCreateFormProps) => {
  const { mergedInitial, restoredAt, baseline } = useMemo(() => {
    const draft = loadDraft(requestId);
    if (!draft) {
      return {
        mergedInitial: initialData,
        restoredAt: null as number | null,
        baseline: initialData,
      };
    }
    return {
      mergedInitial: { ...initialData, ...draft.data },
      restoredAt: draft.savedAt,
      baseline: initialData,
    };
  }, [requestId, initialData]);

  const wrappedAfterSubmit = {
    ...(afterSubmit || {}),
    execute: (response: unknown) => {
      clearDraft(requestId);
      afterSubmit?.execute?.(response);
    },
  };

  return (
    <CreateForm {...rest} initialData={mergedInitial} afterSubmit={wrappedAfterSubmit}>
      <FormDraftManager
        requestId={requestId}
        baselineInitialData={baseline}
        restoredFromSavedAt={restoredAt}
        messageContext={messageContext}
      />
      {children}
    </CreateForm>
  );
};

export default OneStopCreateForm;
